import React from "react";
import { Box, CardMedia, IconButton, Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { rsOpenDrawer, rsToken, rsUserData } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { rsActiveMenu } from "../../RecoilStates";
import LogoutIcon from "@mui/icons-material/Logout";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { UseLogOut } from "./UseLogOut";
import SettingsIcon from "@mui/icons-material/Settings";
import useBreakpoints from "../../hooks/useBreakpoints";
import MenuIcon from "@mui/icons-material/Menu";
import PersonIcon from "@mui/icons-material/Person";

function Header() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const [openDrawer, setOpenDrawer] = useRecoilState(rsOpenDrawer);
  const [msUserData, setMsUserData] = useRecoilState(rsUserData);
  const { logout } = UseLogOut();
  const [msToken, setMsToken] = useRecoilState(rsToken);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const { isSmall } = useBreakpoints();

  const handleClose = () => {
    setAnchorEl(null);
  };

  return isSmall ? (
    <Box
      sx={{
        p: 2,
        height: "8%",
        backgroundColor: "primary.main",
        boxShadow: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <IconButton onClick={() => setOpenDrawer(true)}>
        <MenuIcon sx={{ fill: "#fff" }} />
      </IconButton>
      <CardMedia
        sx={{ width: "30%", mx: "auto" }}
        component="img"
        src={window.ENV.logo1}
        alt="Paella dish"
      />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Button
          sx={{
            display: "flex",
            alignItems: "center",
            color: "#687C82",
          }}
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={(event) => setAnchorEl(event.currentTarget)}
        >
          <Avatar sx={{ bgcolor: "#fff", width: "25px", height: "25px" }}>
            <PersonIcon fontSize="small" color="primary" />
          </Avatar>

          <ArrowDropDownIcon
            fontSize="small"
            sx={{ fill: "#fff" }}
          ></ArrowDropDownIcon>
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem
            sx={{ p: 0, display: "flex", justifyContent: "flex-start" }}
            onClick={handleClose}
          >
            <Button
              sx={{ px: 3 }}
              color="secondary"
              onClick={() => {
                navigate("/setting");
              }}
              startIcon={<SettingsIcon fontSize="small"></SettingsIcon>}
            >
              تنظیمات
            </Button>
          </MenuItem>
          <MenuItem
            sx={{ p: 0, display: "flex", justifyContent: "flex-start" }}
            onClick={handleClose}
          >
            <Button
              sx={{ px: 3 }}
              color="secondary"
              onClick={() => {
                if (msToken) {
                  logout(() => {
                    setMsUserData(undefined);
                    setMsToken(undefined);
                    localStorage.removeItem("ControllPanellToken");
                    localStorage.removeItem("ControllPanellUserData");
                    navigate("/Login");
                  });
                } else {
                  setMsUserData(undefined);
                  setMsToken(undefined);
                  localStorage.removeItem("ControllPanellToken");
                  localStorage.removeItem("ControllPanellUserData");
                  navigate("/Login");
                }
              }}
              startIcon={<LogoutIcon fontSize="small"></LogoutIcon>}
            >
              خروج
            </Button>
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  ) : (
    <Box
      sx={{
        p: 2,
        height: "8%",
        backgroundColor: "primary.main",
        boxShadow: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Typography sx={{ color: "#fff" }} variant="subtitle1">
        {msActiveMenu.pageTitle}
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Button
          sx={{
            display: "flex",
            alignItems: "center",
            color: "#687C82",
            gap: 1,
          }}
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={(event) => setAnchorEl(event.currentTarget)}
        >
          <Avatar sx={{ bgcolor: "#fff", width: "25px", height: "25px" }}>
            <PersonIcon fontSize="small" color="primary" />
          </Avatar>
          <Typography sx={{ color: "#fff" }} variant="body2">
            {msUserData && msUserData.specialty ? msUserData.specialty : ""}
            {msUserData
              ? " " + msUserData.firstName + " " + msUserData.lastName
              : ""}
            {/* {msUserData && msUserData.specialty
              ? msUserData.specialty +
                " " +
                msUserData.firstName +
                " " +
                msUserData.lastName
              : ""} */}
          </Typography>
          <ArrowDropDownIcon sx={{ fill: "#fff" }}></ArrowDropDownIcon>
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem
            sx={{ p: 0, display: "flex", justifyContent: "flex-start" }}
            onClick={handleClose}
          >
            <Button
              sx={{ px: 3 }}
              color="secondary"
              onClick={() => {
                navigate("/setting");
              }}
              startIcon={<SettingsIcon fontSize="small"></SettingsIcon>}
            >
              تنظیمات
            </Button>
          </MenuItem>
          <MenuItem
            sx={{ p: 0, display: "flex", justifyContent: "flex-start" }}
            onClick={handleClose}
          >
            <Button
              sx={{ px: 3 }}
              color="secondary"
              onClick={() => {
                if (msToken) {
                  logout(() => {
                    setMsUserData(undefined);
                    setMsToken(undefined);
                    localStorage.removeItem("ControllPanellToken");
                    localStorage.removeItem("ControllPanellUserData");
                    navigate("/Login");
                  });
                } else {
                  setMsUserData(undefined);
                  setMsToken(undefined);
                  localStorage.removeItem("ControllPanellToken");
                  localStorage.removeItem("ControllPanellUserData");
                  navigate("/Login");
                }
              }}
              startIcon={<LogoutIcon fontSize="small"></LogoutIcon>}
            >
              خروج
            </Button>
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
}

export default Header;
